<template>
  <div class="row">
    <notifications></notifications>
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.documents')"
        :col="3"
      >
        <div class="row mt-2 d-flex justify-content-between">
          <div class="ml-4">
            <button
              class="btn btn-success"
              @click="oeffneDokumentModal"
              v-if="dokumentEditable"
            >
              <font-awesome-icon
                icon="fa-duotone fa-file-import"
                class="mr-2"
              />
              <span>{{ $t("global.new") }}</span>
            </button>
            <button
              class="btn btn-primary ml-2"
              @click="oeffnePublikationszeitraumSetzenModal"
              v-if="berechtigungen.m_korrespondenz.delete"
              :disabled="selectedIds.length === 0"
              :title="selectedIds.length === 0 ? $t('global.selectminone') : ''"
            >
              <font-awesome-icon icon="fad fa-calendar-days" class="mr-2" />{{
                $t("global.setpublicationperiod")
              }}
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-primary mr-2"
              @click="toggleHasMaxHeight"
              v-if="showListToggleButton"
              v-tooltip.hover="
                            hasMaxHeight
                              ? (text = $t('global.expandlist'))
                              : (text = $t('global.collapselist'))
                          "
            >
              <font-awesome-icon
                class="mr-2"
                icon="fa-solid fa-chevron-down"
                v-if="hasMaxHeight === true"
              />
              <font-awesome-icon
                class="mr-2"
                icon="fa-solid fa-chevron-up"
                v-if="hasMaxHeight === false"
              />
              <font-awesome-icon
                icon="fa-solid fa-list"
              />
            </button>
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              v-if="dokumentEditable"
            >
              <font-awesome-icon class="mr-1" icon="fa-duotone fa-trash" />
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div ref="tableParent">
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :style="hasMaxHeight ? 'max-height: 300px' : ''"
              :items="dokumentenliste"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-compare="sortDates"
              :busy="isBusy"
              show-empty
              sort-icon-left
              responsive
              selectable
              select-mode="range"
              @row-dblclicked="details"
              small
              thead-tr-class="pointer"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template #cell(edit)="row">
                <div
                  class="ml-5 d-flex align-items-center"
                  role="button"
                  @click="dokumentBearbeiten(row)"
                >
                  <font-awesome-icon icon="fa-regular fa-pencil" size="sm" />
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <dokument-modal
      :person="this.person"
      :foreigntable="this.foreignTable"
      :foreignkey="this.foreignKey"
      :gptyp="gptyp"
      :aktivitaet="this.aktivitaet"
      :auftrag="this.auftrag"
      :id="dokumentModalId"
    ></dokument-modal>

    <publikationszeitraum-setzen-modal
      :dokumentenIds="selectedIds"
      @updated="publikationszeitraumSetzenGeaendert"
    />

    <loeschen-modal :id="loeschenModalId" @confirmed="dokumentloeschen" />

    <pdf-layer
      id="pdf-layer"
      ref="pdfLayerDokument"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    ></pdf-layer>
  </div>
</template>

<script>
import Api from "@/api/Api";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";

import DokumentModal from "../Modals/DokumentModal.vue";
import PublikationszeitraumSetzenModal from "@/components/Modals/PublikationszeitraumSetzenModal.vue";
import LoeschenModal from "@/components/Modals/LoeschenModal";

import reiter from "@/mixins/Reiter";
import server from "@/server";

import { uuidv4 } from "@/utils/Uuid";

export default {
  name: "Dokumentenliste",
  components: {
    ContainerHeadline,
    DokumentModal,
    PublikationszeitraumSetzenModal,
    LoeschenModal,
    BSpinner,
  },
  mixins: [reiter],
  props: {
    person: {
      type: String,
      required: false,
    },
    foreignKey: {
      type: String,
      required: false,
    },
    foreignTable: {
      type: String,
      required: false,
    },
    anmeldungid: {
      type: String,
      required: false,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    dokumentEditable: {
      type: Boolean,
      required: true,
    },
    gptyp: {
      type: String,
      required: false,
    },
    aktivitaet: {
      type: String,
      required: false,
    },
    auftrag: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      page: 0,
      anzahlProPage: 100,
      sortBy: "",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      pdfFileName: "",
      dokumentenliste: [],
      newDokument: false,
      selected: [],
      selectedIds: [],
      pdfPath: "",
      hasMaxHeight: true,
      showListToggleButton: null,
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "erstellt",
          label: this.$t("global.created"),
          class: this.aktivitaet ? "display-none" : "",
        },
        {
          key: "ersteller.personName",
          label: this.$t("global.creator"),
          class: this.aktivitaet ? "display-none" : "",
        },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
        },
        {
          key: "name",
          sortable: true,
          label: this.$t("global.name"),
          class: this.aktivitaet ? "display-none" : "",
        },
        {
          key: "edit",
          sortable: false,
          label: this.$t("global.edit"),
          class: this.aktivitaet ? "display-none" : "",
        },
      ];
    },
    dokumentModalId() {
      return "dokument-modal-" + uuidv4();
    },
    loeschenModalId() {
      return "loeschen-modal-" + uuidv4();
    },
  },
  watch: {
    shown(val) {
      if (val && this.dokumentenliste.length == 0) this.getDokumente();
    },
    person() {
      if (this.shown && this.dokumentenliste.length == 0) this.getDokumente();
    },
    aktivitaet() {
      if (this.shown && this.dokumentenliste.length == 0) this.getDokumente();
    },
    auftrag() {
      if (this.shown && this.dokumentenliste.length == 0) this.getDokumente();
    },
  },
  mounted() {
    if (this.shown && this.dokumentenliste.length == 0) this.getDokumente();
  },
  created() {},
  methods: {
    getDokumente(newDokument) {
      if (this.dokumentenliste.length == 0 || newDokument) {
        if (
          !this.aktivitaet &&
          !this.person &&
          !this.foreignKey &&
          !this.auftrag
        )
          return;
        this.isBusy = true;

        Api.get("dokument/", {
          params: {
            person: this.foreignTable === "lead" ? null : this.person,
            aktivitaet: this.aktivitaet,
            auftrag: this.auftrag,
            foreignkey: this.foreignKey,
            foreigntable: this.foreignTable,
          },
        })
          .then((response) => {
            this.dokumentenliste = response.data;
            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          })
          .finally(() => {
            this.isBusy = false;
            this.$nextTick(() => {
            this.showListToggleButton = !(
              this.$refs.tableParent.clientHeight < 300
            );
          });
          });
      }
    },

    details(dokument) {
      if (dokument.person) {
        if (dokument.mimetype == "application/pdf") {
          // this.pdfPath = server.url + dokument.dokument;
          // this.$refs.pdfLayerDokumentReiter.show();
          this.$router.push({
            path: "/ressourcen/dokument/" + dokument.id,
          });
        } else {
          this.$router.push({
            path: "/ressourcen/dokument/" + dokument.id,
          });
        }
      } else {
        this.pdfPath = server.url + "/" + dokument.dokument;
        this.$refs.pdfLayerDokument.show();
      }
    },

    dokumentBearbeiten(row) {
      this.$router.push({
        path: "/ressourcen/dokument/" + row.item.id,
      });
    },

    oeffneDokumentModal() {
      $(`#${this.dokumentModalId}`).modal("show");
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", this.loeschenModalId);
      else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nodocumentselected"),
        });
      }
    },

    dokumentloeschen() {
      Api.delete("dokument/", {
        params: { ids: this.selectedIds.join(",") },
      })
        .then(() => {
          this.$emit("updateComponent");
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: `${this.selectedIds.length} ${this.$t(
              "global.documentsdeleted"
            )}`,
          });
        })
        .finally(() => {
          this.getDokumente();
        });
    },

    publikationszeitraumSetzenGeaendert() {
      this.getDokumente();
    },

    oeffnePublikationszeitraumSetzenModal() {
      this.$bus.$emit("openPublikationszeitraumSetzenModal");
    },
    toggleHasMaxHeight() {
      this.hasMaxHeight = !this.hasMaxHeight;
    },
  },
};
</script>
